import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  qrRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12
  },
  chipsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 12
  },
  chip: {
    backgroundColor: '#EEF0F2',
    fontWeight: 500
  }
});
